function UserRole() {
    "use strict";
    this.__type = 'UserRole:www.veritracks.com';
    this.Id = -1;
    this.UserId = -1;
    this.Description = null;
    this.UserRoleValueTypeId = -1;
    this.TransactionId = '';
}
if (typeof exports !== 'undefined') {
    module.exports = UserRole;
}